const MarquiseDiamond = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M76.6,50c0-10.04-2.57-19.23-7.85-28.11c0,0-0.01-0.01-0.01-0.01c0,0,0,0,0,0c0,0,0,0,0,0
	C64.68,15.06,58.66,9.05,50.33,3.5c-0.02-0.01-0.04-0.02-0.06-0.03c-0.03-0.01-0.06-0.03-0.09-0.04c-0.03-0.01-0.06-0.01-0.09-0.02
	c-0.03,0-0.06-0.01-0.09-0.01c-0.03,0-0.06,0.01-0.09,0.01c-0.03,0-0.06,0.01-0.09,0.02c-0.03,0.01-0.06,0.02-0.09,0.04
	c-0.02,0.01-0.04,0.02-0.07,0.03c-8.33,5.55-14.35,11.56-18.4,18.37c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.01,0.01-0.01,0.01
	C25.97,30.77,23.4,39.96,23.4,50s2.57,19.23,7.85,28.11c0,0,0.01,0.01,0.01,0.01c0,0,0,0,0,0c0,0,0,0,0,0
	c4.06,6.81,10.08,12.82,18.4,18.37c0.01,0.01,0.02,0,0.03,0.01c0.09,0.06,0.2,0.09,0.3,0.09s0.21-0.04,0.3-0.09
	c0.01-0.01,0.02,0,0.03-0.01c8.33-5.55,14.35-11.56,18.4-18.37c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.01-0.01,0.01-0.01
	C74.03,69.23,76.6,60.04,76.6,50z M68.43,76.22l-3.76-14.04l10.71-10.71C75.15,60.24,72.85,68.36,68.43,76.22z M55.51,78.81
	l-4.58-3.81l5.34-4.58L55.51,78.81z M50,94.29l-5.29-14.1L50,75.78l5.29,4.41L50,94.29z M44.49,21.19L49.07,25l-5.34,4.58
	L44.49,21.19z M50,5.71l5.29,14.1L50,24.22l-5.29-4.41L50,5.71z M50,74.21l-6.44-5.52L40.61,50l2.95-18.69L50,25.79l6.44,5.52
	L59.39,50l-2.95,18.69L50,74.21z M39.79,47.47l-3.1-9.31l5.43-5.43L39.79,47.47z M39.79,52.52l2.33,14.75l-5.43-5.43L39.79,52.52z
	 M60.21,47.47l-2.33-14.75l5.43,5.43L60.21,47.47z M60.21,52.52l3.1,9.31l-5.43,5.43L60.21,52.52z M64.26,60.89L60.63,50l3.63-10.89
	L75.15,50L64.26,60.89z M63.69,36.84l-6.11-6.11l-0.91-10l10.82,1.94L63.69,36.84z M55.51,21.19l0.76,8.39L50.93,25L55.51,21.19z
	 M42.42,30.73l-6.11,6.11l-3.79-14.17l10.82-1.94L42.42,30.73z M35.74,39.11L39.37,50l-3.63,10.89L24.85,50L35.74,39.11z
	 M36.31,63.16l6.11,6.11l0.91,10l-10.82-1.94L36.31,63.16z M44.49,78.81l-0.76-8.39l5.34,4.58L44.49,78.81z M57.58,69.27l6.11-6.11
	l3.79,14.17l-10.82,1.94L57.58,69.27z M64.67,37.82l3.76-14.04c4.42,7.86,6.73,15.98,6.95,24.75L64.67,37.82z M66.99,21.36
	l-10.55-1.89L51.23,5.56C58.15,10.4,63.32,15.59,66.99,21.36z M48.77,5.56l-5.21,13.91l-10.55,1.89
	C36.68,15.59,41.85,10.4,48.77,5.56z M31.57,23.78l3.76,14.04L24.62,48.53C24.85,39.76,27.15,31.64,31.57,23.78z M35.33,62.18
	l-3.76,14.04c-4.42-7.86-6.73-15.98-6.95-24.75L35.33,62.18z M33.01,78.64l10.55,1.89l5.21,13.91C41.85,89.6,36.68,84.4,33.01,78.64
	z M51.23,94.43l5.21-13.91l10.55-1.89C63.32,84.4,58.15,89.6,51.23,94.43z"
      />
    </svg>
  )
}

export default MarquiseDiamond
